/* SPACES: dimension lines (width / height in cm) around the artwork in the to-scale room views */
(function () {
  function $(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function setup(root) {
    var lab = root.querySelector('.sp-try-lab,.sp-size-lab');
    if (!lab) return;
    function upd() {
      var m = (lab.textContent || '').match(/(\d+)\s*[×x]\s*(\d+)\s*cm/);
      if (!m) return;
      $('.sp-wa', root).forEach(function (wa) {
        var d = wa.querySelector('.sp-dim.w');
        if (!d) { wa.insertAdjacentHTML('beforeend', '<span class="sp-dim w"><b></b></span><span class="sp-dim h"><b></b></span>'); d = wa.querySelector('.sp-dim.w'); }
        d.querySelector('b').textContent = m[1] + ' cm';
        wa.querySelector('.sp-dim.h b').textContent = m[2] + ' cm';
      });
    }
    new MutationObserver(upd).observe(lab, { childList: true, characterData: true, subtree: true });
    upd();
  }
  function init() { $('.sp-try,.sp-hero-stage').forEach(function (r) { if (!r.__dim) { r.__dim = 1; setup(r); } }); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
